export { default } from './EzForm.vue';
